export const LandingUrls = {
    HOME: "/",
    ABOUT: "/about-us",
    CONTACT: "/contact-us",
    PRICING: "/pricing-plan",
    LOGIN: "/sign-in",
    REGISTER: "/sign-up",
    FORGET: "/forget",
    TERMS: "/terms",
    POLICY: "/policy",
    FAQ: "/faq",
    PAYMENT_STATUS: "/payment/:status",
    STORE_SELECT: "/select-store",
};

// const DASHBOARD_ROOT = "/dashboard-panel";

export const DashboardUrls = {
    HOME: "/dashboard",
    SELL: "/sell",
};
